import { render, staticRenderFns } from "./DateInput.vue?vue&type=template&id=dd7560a4&scoped=true&"
import script from "./DateInput.vue?vue&type=script&lang=ts&"
export * from "./DateInput.vue?vue&type=script&lang=ts&"
import style0 from "./DateInput.vue?vue&type=style&index=0&id=dd7560a4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd7560a4",
  null
  
)

export default component.exports